import React, { useEffect, useState } from 'react';
import '../HotelOnboardingWizard.css';
import {
  FaHotel,
  FaBed,
  FaImage,
  FaCog,
  FaDesktop,
  FaPlay,
  FaPhotoVideo,
  FaUpload,
  FaCheckCircle
} from 'react-icons/fa';
import ConfigurationNewRoom from './ConfigurationNewRoom/ConfigurationNewRoom';
import ConfigurationBackgroundImage from './ConfigurationBackgroundImage/ConfigurationBackgroundImage';
import ConfigurationManagementForm from './ConfigurationManagementForm/ConfigurationManagementForm';
import ScreensaverConfiguration from './ScreensaverConfiguration/ScreensaverConfiguration';
import HotelServiceConfiguration from './HotelServiceConfiguration/HotelServiceConfiguration';
import RailConfig from './RailConfiguration/RailConfig';
import DefaultWelcomeScreen from './DefaultWelcomeScreen/DefaultWelcomeScreen';
import BasicModal from '../../../core/BaseComponents/Modal';
import CustomizeWelcomeScreen from './CustomizeWelcomeScreen/CustomizeWelcomeScreen';

const HmsHotelOnboardingWizard = ({selectedHotelDetails}) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [wizardComplete, setWizardComplete] = useState(false)

  useEffect(()=>{
    setCurrentStep(0)
  },[selectedHotelDetails])

  const steps = [
    {
      id: 1,
      title: 'Room Type & CDSN Mapping',
      icon: <FaBed />,
      component: <ConfigurationNewRoom />
    },
    {
      id: 2,
      title: 'Upload Background Image',
      icon: <FaImage />,
      component: <ConfigurationBackgroundImage />
    },
    {
      id: 3,
      title: 'Upload Hotel Services',
      icon: <FaCog />,
      component: <HotelServiceConfiguration />
    },
    {
      id: 4,
      title: 'Create Welcome Screen Config',
      icon: <FaDesktop />,
      component: <DefaultWelcomeScreen />
    },
    {
      id: 5,
      title: 'Assign welcome screen on Rooms',
      icon: <FaDesktop />,
      component: <CustomizeWelcomeScreen />
    },
    {
      id: 6,
      title: 'Upload Hero Banners',
      icon: <FaPhotoVideo />,
      component: <ConfigurationManagementForm />
    },
    {
      id: 7,
      title: 'Upload Screensaver Images',
      icon: <FaUpload />,
      component: <ScreensaverConfiguration />
    },
    {
      id: 8,
      title: 'Create Rail Config and Publish',
      icon: <FaCheckCircle />,
      component: <RailConfig />
    }
  ];

  const handleNext = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
    }
    else if(currentStep === steps.length - 1){
      setWizardComplete(true)
    }
  };

  const handlePrevious = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleStepClick = (index) => {
    setCurrentStep(index);
  };

  return (
    <div className="wizard-container">
      <div className="wizard-header">
        <h1>HMS Hotel Onboarding Wizard for : <strong>{selectedHotelDetails?.navSelectedhotelName?.length>0?selectedHotelDetails?.navSelectedhotelName[0]?.name:""}</strong></h1>
      </div>

      {/* Stepper */}
      <div className="stepper">
        <div className="stepper-line-hms"></div>
        {steps.map((step, index) => (
          <div
            key={step.id}
            className={`stepper-step ${index <= currentStep ? 'active' : ''} ${
              index < currentStep ? 'completed' : ''
            }`}
            onClick={() => handleStepClick(index)}
          >
            <div className="step-circle">
              <div className="step-icon">{step.icon}</div>
            </div>
            <div className="step-label">{step.title}</div>
          </div>
        ))}
      </div>

      {/* Step Content */}
      <div className="step-content">
        {steps[currentStep].component}
      </div>

      {/* Navigation Buttons */}
      <div className="wizard-navigation">
        <button
          className="btn btn-secondary"
          onClick={handlePrevious}
          disabled={currentStep === 0}
        >
          Previous
        </button>
        <div className="step-indicator">
          Step {currentStep + 1} of {steps.length}
        </div>
        <button
          className="btn btn-primary"
          onClick={handleNext}
          // disabled={currentStep === steps.length - 1}
        >
          {currentStep === steps.length - 1 ? 'Finish' : 'Next'}
        </button>
      </div>
      <BasicModal
          popupOpen={wizardComplete}
          logo={"/Images/approve-qc.png"}
          bodyMessage={<p className="mt-2">Hotel Onboarded Successfully</p>}
          footer={
            {
              secondaryButton: {
                buttonName: "OK",
                action: () => { setWizardComplete(false) },
                buttonPrimaryCustomCss: 'cancel-btn_new'
              }
            }
          }
        />
    </div>
  );
};

// Step Components

// const RoomTypeMappingStep = () => (
//   <div className="step-form">
//     <h2>Room Type & CDSN Mapping</h2>
//     <div className="form-group">
//       <label>Room Type</label>
//       <input type="text" placeholder="Enter room type" />
//     </div>
//     <div className="form-group">
//       <label>CDSN Number</label>
//       <input type="text" placeholder="Enter CDSN" />
//     </div>
//   </div>
// );

// const BackgroundImageStep = () => (
//   <div className="step-form">
//     <h2>Upload Background Image</h2>
//     <div className="upload-area">
//       <FaImage size={50} />
//       <p>Click or drag to upload background image</p>
//       <input type="file" accept="image/*" />
//     </div>
//   </div>
// );

// const HotelServicesStep = () => (
//   <div className="step-form">
//     <h2>Upload Hotel Services</h2>
//     <div className="form-group">
//       <label>Service Name</label>
//       <input type="text" placeholder="Enter service name" />
//     </div>
//     <div className="upload-area">
//       <FaCog size={50} />
//       <p>Upload service icon or image</p>
//       <input type="file" accept="image/*" />
//     </div>
//   </div>
// );

// const WelcomeScreenStep = () => (
//   <div className="step-form">
//     <h2>Create Welcome Screen Config</h2>
//     <div className="form-group">
//       <label>Welcome Message</label>
//       <textarea placeholder="Enter welcome message" rows="4"></textarea>
//     </div>
//     <div className="form-group">
//       <label>Background Color</label>
//       <input type="color" />
//     </div>
//   </div>
// );

// const HeroBannersStep = () => (
//   <div className="step-form">
//     <h2>Upload Hero Banners</h2>
//     <div className="upload-area">
//       <FaPhotoVideo size={50} />
//       <p>Upload hero banner images (recommended: 1920x1080)</p>
//       <input type="file" accept="image/*" multiple />
//     </div>
//   </div>
// );

// const ScreensaverStep = () => (
//   <div className="step-form">
//     <h2>Upload Screensaver Images</h2>
//     <div className="upload-area">
//       <FaUpload size={50} />
//       <p>Upload screensaver images</p>
//       <input type="file" accept="image/*" multiple />
//     </div>
//   </div>
// );

// const PublishStep = () => (
//   <div className="step-form">
//     <h2>Create Rail Config and Publish</h2>
//     <div className="info-box success">
//       <FaCheckCircle size={50} />
//       <p>Review all configurations and publish your hotel onboarding.</p>
//       <button className="btn btn-success">Publish Configuration</button>
//     </div>
//   </div>
// );

export default HmsHotelOnboardingWizard;
